import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './index.css';

export default class ScrollBox extends Component {
  state = {
    showIcon: true,
  };

  selfRef = React.createRef();

  handleScroll = this.handleScroll.bind(this);

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.children.props) {
      this.setState({ showIcon: newProps.children.props.children.length > 9 });
    }
  }

  componentDidMount() {
    const { current } = this.selfRef;
    current.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    this.selfRef.current.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    this.setState({ showIcon: event.srcElement.scrollTop < 3 });
  }

  render() {
    const { height, children, color } = this.props;
    // const { showIcon } = this.state;
    // {showIcon && <FontAwesomeIcon color={color} style={{ fontSize: '24px' }} icon="caret-down" />}
    return (
      <div name="scroll-box" ref={this.selfRef} style={{ height, overflow: 'scroll' }}>
        {children}
      </div>
    );
  }
}
